module.exports = __webpack_public_path__ + "img/step-1-image.6a13d5fd.svg";